import sicknesscategory from '@/modules/apies/public/sicknesscategory.js'
import authentication from '@/modules/apies/authentication'
import foodmeal from '@/modules/apies/food/foodmeal'
import foodcategory from '@/modules/apies/food/foodcategory'
import foodunit from '@/modules/apies/food/foodunit'
import food from '@/modules/apies/food/food'
import foodrecipes from '@/modules/apies/food/foodrecipes'
import foodrecipescomment from '@/modules/apies/food/foodrecipescomment'
import country from '@/modules/apies/public/country'
import state from '@/modules/apies/public/state'
import sickness from '@/modules/apies/public/sickness'
import foodindicator from '@/modules/apies/food/foodindicator'
import foodsuggestion from '@/modules/apies/food/foodsuggestion'
import foodlist from '@/modules/apies/food/foodlist'
import foodcomment from '@/modules/apies/food/foodcomment'
import user from '@/modules/apies/user/user'
import userrole from '@/modules/apies/user/userrole'
import userpermission from '@/modules/apies/user/userpermission'
import content from '@/modules/apies/public/content'
import version from '@/modules/apies/public/version'
import diet from '@/modules/apies/diet/diet'
import dietduration from '@/modules/apies/diet/dietduration'
import dietdurationprice from '@/modules/apies/diet/dietdurationprice'
import activity from '@/modules/apies/activity/activity'
import activitycomment from '@/modules/apies/activity/activitycomment'
import activitypackagecomment from '@/modules/apies/activity/activitypackagecomment'
import activitycategory from '@/modules/apies/activity/activitycategory'
import activitypackage from '@/modules/apies/activity/activitypackage'
import activitypackagecourse from '@/modules/apies/activity/activitypackagecourse'
import activitygroup from '@/modules/apies/activity/activitygroup'
import city from '@/modules/apies/public/city'
import shorturl from '@/modules/apies/public/shorturl'
import discount from '@/modules/apies/order/discount'
import userdietorder from '@/modules/apies/order/userdietorder'
import activitypackageorder from '@/modules/apies/order/activitypackageorder'
import faq from '@/modules/apies/public/faq'
import faqcategory from '@/modules/apies/public/faqcategory'
import ticketdepartment from '@/modules/apies/ticket/ticketdepartment'
import ticket from '@/modules/apies/ticket/ticket'
import UserSickness from '@/modules/apies/user/userSickness'
import userPlanFood from '@/modules/apies/user/userPlanFood'
import userDietTerms from '@/modules/apies/user/userDietTerms'
import muscle from '@/modules/apies/activity/muscle'
import banner from '@/modules/apies/banner/banner'
import bannerposition from '@/modules/apies/banner/bannerposition'
import report from '@/modules/apies/report/report'
import blog from '@/modules/apies/blog/blog'
import blogcategory from '@/modules/apies/blog/blogcategory'
import blogcomment from '@/modules/apies/blog/blogcomment'
import slider from '@/modules/apies/blog/slider'
import segmentBasic from '@/modules/apies/segment/segmentBasic'
import segmentCustom from '@/modules/apies/segment/segmentCustom'
import segmentReports from '@/modules/apies/segment/segmentReports'
import declarations from '@/modules/apies/segment/decleration'
import announcement from '@/modules/apies/segment/announcement'

import calorie from '@/modules/apies/dedicatedDiet/calorie'
import supplement from '@/modules/apies/dedicatedDiet/supplement'
import recommend from '@/modules/apies/dedicatedDiet/recommend'
import recommendcategory from '@/modules/apies/dedicatedDiet/recommendcategory'
import dedicatedfoodList from '@/modules/apies/dedicatedDiet/foodList'
import dedicatedDietList from '@/modules/apies/dedicatedDiet/dedicatedDietList'
import errorlog from '@/modules/apies/errorLog/errorLog'
import question from '@/modules/apies/question/question'
import userspecialdiet from "@/modules/apies/user/userspecialdiet"
import userQuestionAnswer from "@/modules/apies/user/userQuestionAnswer"
import userQuestionAnswerSheet from "@/modules/apies/user/userQuestionAnswerSheet"
import usertoken from "@/modules/apies/user/usertoken"
import useraffiliate from "@/modules/apies/affiliate/useraffiliate"
import useraffiliatesettlement from "@/modules/apies/affiliate/useraffiliatesettlement"
import hero from '@/modules/apies/hero/hero'
import herocomment from '@/modules/apies/hero/herocomment'
import product from '@/modules/apies/product/product'
import channels from '@/modules/apies/campaign/channels'
import campaigns from '@/modules/apies/campaign/campaigns'
import attributions from '@/modules/apies/campaign/attributions'
import charges from '@/modules/apies/campaign/charges'
import nutritionist from '@/modules/apies/user/nutritionist'
import fileManager from "@/modules/apies/public/fileManager"
import landing from "@/modules/apies/blog/landing"
import alternativeCalorie from '@/modules/apies/diet/alternativeCalorie'
import messenger from '@/modules/apies/messenger/messenger'
import evaluationMessage from '@/modules/apies/public/evaluationMessage'
import prizeWheel from '@/modules/apies/prizeWheel'
import callRequests from '@/modules/apies/callCenter/callRequests'
import callCenterList from '@/modules/apies/callCenter/callCenterList'
import bill from '@/modules/apies/bill/bill'
export default {
  authentication,
  foodmeal,
  foodcategory,
  foodunit,
  food,
  country,
  state,
  sickness,
  foodindicator,
  foodsuggestion,
  foodlist,
  user,
  userrole,
  userpermission,
  content,
  version,
  diet,
  activity,
  activitycategory,
  city,
  dietduration,
  dietdurationprice,
  discount,
  userdietorder,
  foodcomment,
  faq,
  faqcategory,
  ticketdepartment,
  ticket,
  UserSickness,
  userPlanFood,
  userDietTerms,
  muscle,
  activitypackage,
  activitypackagecourse,
  banner,
  bannerposition,
  report,
  activitygroup,
  activitypackageorder,
  blog,
  blogcomment,
  slider,
  blogcategory,
  sicknesscategory,
  segmentBasic,
  segmentCustom,
  segmentReports,
  declarations,
  errorlog,
  calorie,
  supplement,
  recommend,
  recommendcategory,
  dedicatedfoodList,
  dedicatedDietList,
  question,
  shorturl,
  foodrecipes,
  activitycomment,
  activitypackagecomment,
  foodrecipescomment,
  userspecialdiet,
  userQuestionAnswer,
  userQuestionAnswerSheet,
  usertoken,
  useraffiliate,
  useraffiliatesettlement,
  hero,
  herocomment,
  product,
  channels,
  campaigns,
  attributions,
  charges,
  nutritionist,
  fileManager,
  landing,
  alternativeCalorie,
  messenger,
  evaluationMessage,
  prizeWheel,
  callRequests,
  callCenterList,
  announcement,
  bill
}
